import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import PageHeader from '@features/PageHeader';
import Button from '@components/Button';
import { IntegrationRequiredIcon } from 'assets/images/icons';
import { useTranslation, usePermissions } from '@hooks';
import { ExternalRoutes, RoutePath } from '@constants/routes';

const IntegrationRequired = ({ googleOnly = false }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const user = useSelector(state => state.auth.user);
    const { hasFullSettings } = usePermissions();

    const onClickLearnMore = () => {
        window.open(ExternalRoutes.IntegrationLearnMore[user?.language], '_blank');
    };

    return (
        <PageHeader
            icon={<IntegrationRequiredIcon />}
            title={t('IntegrationRequired.title')}
            subtitle={t(`IntegrationRequired.${googleOnly ? 'subtitleGoogle' : 'subtitleCommon'}`)}
            styles={{ marginBottom: '16px' }}
        >
            {hasFullSettings() && (
                <Button variant="contained" onClick={() => navigate(RoutePath.AccountSettingsIntegrations)}>
                    {t('buttons.connect')}
                </Button>
            )}
            <Button variant="outlined" onClick={onClickLearnMore}>
                {t('common.learnMore')}
            </Button>
        </PageHeader>
    );
};

export default IntegrationRequired;
